// extracted by mini-css-extract-plugin
export default {"container":"x4LlC","placeholder":"oGMY-"};